import React, { useCallback, useEffect } from "react";
import {
  GridLayout,
  GridLayoutItem,
  Stepper,
  StepperChangeEvent,
} from "@progress/kendo-react-layout";
import TourInformation from "./tourforms/TourInformation";
import TourPlaces from "./tourforms/TourPlaces";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearActiveStep, setActiveStep } from "./tourSlice";
import TourRates from "./tourforms/TourRates";
import TourItinerary from "./tourforms/TourItinerary";
import TourFixedTransfers from "./tourforms/TourFixedTransfers";
import TourFixedSightseens from "./tourforms/TourFixedSightseens";
import TourFixedMeals from "./tourforms/TourFixedMeals";

type ActiveStepProps = {
  step: number;
};

const steps = [
  { label: "Tour Information", isValid: undefined },
  { label: "Tour Places", isValid: undefined },
  { label: "Tour Rates", isValid: undefined },
  { label: "Tour Itinerary", isValid: undefined },
  { label: "Tour Fixed Transfers", isValid: undefined },
  { label: "Tour Fixed Sightseens", isValid: undefined },
  { label: "Tour Fixed Meals", isValid: undefined },
];

const CreateTour: React.FC = () => {
  const dispatch = useAppDispatch();
  const ActiveStep = useAppSelector((state) => state.tour.ActiveStep);

  useEffect(() => {
    return () => {
      dispatch(clearActiveStep());
    };
  }, []);

  const renderActiveStep: React.FC<ActiveStepProps> = useCallback(
    ({ step }) => {
      switch (step) {
        case 0:
          return <TourInformation />;
        case 1:
          return <TourPlaces />;
        case 2:
          return <TourRates />;
        case 3:
          return <TourItinerary />;
        case 4:
          return <TourFixedTransfers />;
        case 5:
          return <TourFixedSightseens />;
        case 6:
          return <TourFixedMeals />;
        default:
          return <TourInformation />;
      }
    },
    [ActiveStep]
  );

  const handleChange = (e: StepperChangeEvent) => {
    if (location.pathname !== "/tour/create" || e?.value === 0) {
      dispatch(setActiveStep(e.value));
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem
        style={{
          padding: "15px 0",
        }}
      >
        <Stepper value={ActiveStep} onChange={handleChange} items={steps} />
      </GridLayoutItem>
      <GridLayoutItem>{renderActiveStep({ step: ActiveStep })}</GridLayoutItem>
    </GridLayout>
  );
};

export default CreateTour;
